module.exports = __webpack_public_path__ + "static/img/hotTopBg.91c583e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rank/hotTopBg.png
// module id = o0hq
// module chunks = 0